import { styled } from "styled-components";

import { IconButton } from "@similarweb/ui-components";

export const StyledTableContainer = styled.div`
    .ant-table-tbody .ant-table-row {
        .visibleOnRowHover {
            display: none;
        }

        &:hover .visibleOnRowHover {
            display: flex;
        }
    }
`;

export const StyledEmailCopyButton = styled(IconButton)`
    flex-shrink: 0;
`;

export const StyledTabsWrapper = styled.div`
    li:last-of-type,
    li:first-of-type {
        border-left: none;
    }
`;
